  var swiper = new Swiper(".image_container_main", {
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });


   var cartIcon=document.querySelectorAll(".container_icon_add_tocart");
   cartIcon.forEach(function(ele){
     console.log(cartIcon);
     ele.addEventListener("click", function(e){
       e.preventDefault();
      var parentCard=ele.parentNode;
       var parentParentcard=parentCard.parentNode;
       var btn=parentParentcard.querySelector(".custom_btn_card button");
       console.log(btn);
      btn.click();
    });
   });
    